module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/ja-技术研发.e6705926.png";